import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = 'https://staff.praxisamring-hameln.de';

// Get auth token from localStorage or cookies
const getAuthToken = () => {
  return (
    localStorage.getItem('authToken') ||
    Cookies.get('jwtToken') ||
    null
  );
};

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Authorization': `Bearer ${getAuthToken()}`,
    'Content-Type': 'multipart/form-data',
  },
});

// Staff service methods
export const staffService = {
  // Get all staff members
  getAllStaff: async () => {
    try {
      console.log('[staffService] GET /staff/staff', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/staff/staff`
      });
      const response = await apiClient.get('/staff/staff');
      return response.data;
    } catch (error) {
      console.error('Error fetching staff:', error);
      throw error;
    }
  },

  // Get single staff member by ID
  getStaffById: async (id) => {
    try {
      console.log('[staffService] GET /staff/staff/:id', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/staff/staff/${id}`
      });
      const response = await apiClient.get(`/staff/staff/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching staff member:', error);
      throw error;
    }
  },

  // Create new staff member
  createStaff: async (staffData) => {
    try {
      const formData = new FormData();
      // Add file if provided
      if (staffData.profilePhoto) {
        formData.append('profilePhoto', staffData.profilePhoto);
      }
      // Add other fields
      formData.append('firstName', staffData.firstName);
      formData.append('lastName', staffData.lastName);
      formData.append('jobTitle', staffData.jobTitle);
      formData.append('description', staffData.description || '');

      const logPayload = {
        url: `${API_BASE_URL}/staff/add-staff`,
        token: getAuthToken(),
        formDataKeys: Array.from(formData.keys()),
        formDataValues: Array.from(formData.entries()),
      };
      console.log('[staffService] POST /staff/add-staff', logPayload);

      const response = await axios.post(`${API_BASE_URL}/staff/add-staff`, formData, {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating staff member:', error);
      throw error;
    }
  },

  // Update staff member
  updateStaff: async (id, staffData) => {
    try {
      const formData = new FormData();
      // Add file if provided
      if (staffData.profilePhoto) {
        formData.append('profilePhoto', staffData.profilePhoto);
      }
      // Add other fields
      formData.append('firstName', staffData.firstName);
      formData.append('lastName', staffData.lastName);
      formData.append('jobTitle', staffData.jobTitle);
      formData.append('description', staffData.description || '');

      const logPayload = {
        url: `${API_BASE_URL}/staff/update-staff/${id}`,
        token: getAuthToken(),
        formDataKeys: Array.from(formData.keys()),
        formDataValues: Array.from(formData.entries()),
      };
      console.log('[staffService] PUT /staff/update-staff/:id', logPayload);

      const response = await axios.put(`${API_BASE_URL}/staff/update-staff/${id}`, formData, {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating staff member:', error);
      throw error;
    }
  },

  // Delete staff member
  deleteStaff: async (id) => {
    try {
      console.log('[staffService] DELETE /staff/delete-staff/:id', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/staff/delete-staff/${id}`
      });
      const response = await apiClient.delete(`/staff/delete-staff/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting staff member:', error);
      throw error;
    }
  },
}; 